import React from 'react';

import Dashboard from '../dashboard/Dashboard';
import Tasks from '../tasks/Tasks';
import Personnel from '../personnel/Personnel';
import UsersPage from '../users/UsersPage';
import Profile from '../profile/Profile';
import AiUsagePage from '../aichat/usage/AiUsagePage';
import Reports from '../reports/Reports';
import EndOfDayReport from '../reports/EndOfDayReport';
import EndOfDayReportsList from '../reports/EndOfDayReportsList';
import ReportsHub from '../reports/hub/ReportsHub';
import Messages from '../messages/Messages';
import Surveys from '../../pages/Surveys';
import ShiftsPage from '../../pages/Shifts';
import PdksManagement from '../pdks/PdksManagement';
import BranchesPage from '../../pages/Branches';
import CustomerScreenPage from '../../pages/CustomerScreen';
import Events from '../events/Events';
import Reservations from '../reservations/Reservations';
import Accounts from '../accounting/accounts/Accounts';
import AccountMovementsReport from '../accounting/accounts/AccountMovementsReport';
import Inventory from '../accounting/inventory/Inventory';
import LotsPage from '../accounting/inventory/lots/LotsPage';
import ImageLibrary from '../accounting/inventory/ImageLibrary';
import BranchPrices from '../accounting/branchPrices/BranchPrices';
import LabelPrintingPage from '../labelPrinting/LabelPrintingPage';
import StockMovementsReport from '../accounting/inventory/StockMovementsReport';
import PriceChangeLogs from '../accounting/inventory/PriceChangeLogs';
import ProductRecipes from '../accounting/inventory/ProductRecipes';
import ProductMenus from '../accounting/inventory/ProductMenus';
import Bank from '../accounting/bank/Bank';
import Loans from '../accounting/bank/loans/Loans';
import LoanPayments from '../accounting/bank/loans/LoanPayments';
import BankTransactionReport from '../accounting/bank/BankTransactionReport';
import Cashbox from '../accounting/cashbox/Cashbox';
import AccountingDashboard from '../accounting/dashboard/Dashboard';
import Warehouse from '../accounting/warehouse/Warehouse';
import ProductionOrders from '../production/pages/ProductionOrders';
import ProductionPlanning from '../production/pages/ProductionPlanning';
import ProductionTree from '../production/pages/ProductionTree';
import ProductionReports from '../production/pages/ProductionReports';
import ProductionDefinitions from '../production/pages/ProductionDefinitions';
import ProductionWorkshop from '../production/pages/ProductionWorkshop';
import Currency from '../accounting/currency/Currency';
import MailReports from '../accounting/mailReports/MailReports';
import Invoice from '../accounting/invoice/Invoice';
import InvoiceReports from '../accounting/invoice/InvoiceReports';
import EInvoice from '../accounting/e-invoice/E-Invoice';
import PavoPayIntegrations from '../accounting/e-invoice/PavoPayIntegrations';
import Offers from '../accounting/offers/Offers';
import Waybills from '../accounting/waybills/Waybills';
import AccountingOrdersPage from '../accounting/orders/OrdersPage';
import ChecksNotes from '../accounting/checksNotes/ChecksNotes';
import Projects from '../accounting/projects/Projects';
import ProfitLoss from '../accounting/profitLoss/ProfitLoss';
import ExpenseCategoriesPage from '../accounting/cashbox/ExpenseCategoriesPage';
import QuickSalePage from '../salesSystem/quickSale/QuickSalePage';
import RestaurantPage from '../salesSystem/restaurant/RestaurantPage';
import OrderManagementPage from '../salesSystem/orderManagement/OrderManagementPage';
import AllOrdersPage from '../salesSystem/orderManagement/AllOrdersPage';
import RestaurantOrdersReport from '../salesSystem/restaurant/components/RestaurantOrdersReport';
import QRMenuPage from '../../components/qr-menu/QRMenuPage';
import KitchenMenuSelection from '../kitchen/KitchenMenuSelection';
import PoleDisplayManagement from '../pole-display/PoleDisplayManagement';
import PoleDisplayMenuSelection from '../pole-display/PoleDisplayMenuSelection';
import OrdersPage from '../../components/qr-menu/components/OrdersPage';
import CustomersPage from '../../components/qr-menu/components/CustomersPage';
import TablesPage from '../../components/qr-menu/components/TablesPage';
import KioskMenuPage from '../kiosk/KioskMenuPage';
import KioskProducts from '../kiosk/KioskProducts';
import ClubEntryPage from '../salesSystem/clubEntry/ClubEntryPage';
import ECommercePage from '../e-commerce/ECommercePage';
import HaciogluProductMapping from '../e-commerce/components/HaciogluProductMapping';
import CourierManagement from '../couriers/CourierManagement';
import IntegrationPage from '../integrations/IntegrationPage';
import DeviceManagement from '../device-management/DeviceManagement';
import ScaleManagement from '../device-management/ScaleManagement';
import Cards from '../cardManagement/Cards';
import CardSessions from '../cardManagement/CardSessions';
import DeletedCards from '../cardManagement/DeletedCards';
import AccessManagement from '../cardManagement/AccessManagement';
import QuickStartPage from '../quick-start/QuickStartPage';
import LeaveManagementPage from '../human-resources/leave-management/LeaveManagementPage';
import PerformanceManagementPage from '../human-resources/performance-management/PerformanceManagementPage';
import TrainingDevelopmentPage from '../human-resources/training-development/TrainingDevelopmentPage';
import PayrollPaymentsPage from '../human-resources/payroll-payments/PayrollPaymentsPage';
import DocumentManagementPage from '../human-resources/document-management/DocumentManagementPage';
import RecruitmentManagementPage from '../human-resources/recruitment-management/RecruitmentManagementPage';

// WMS Sayfaları
import WmsDashboard from '../wms/pages/WmsDashboard';
import WmsWarehouseSetup from '../wms/pages/WmsWarehouseSetup';
import WmsLocationManager from '../wms/pages/WmsLocationManager';
import WmsOrderPool from '../wms/pages/WmsOrderPool';
import WmsCancelManagement from '../wms/pages/WmsCancelManagement';
import WmsWaveManagement from '../wms/pages/WmsWaveManagement';
import WmsReceivingManagement from '../wms/pages/WmsReceivingManagement';
import WmsCycleCountManagement from '../wms/pages/WmsCycleCountManagement';
import WmsEquipmentManagement from '../wms/pages/WmsEquipmentManagement';
import WmsPickingSetup from '../wms/pages/WmsPickingSetup';
import WmsPackingSetup from '../wms/pages/WmsPackingSetup';
import WmsReceivingSetup from '../wms/pages/WmsReceivingSetup';
import WmsCycleCountSetup from '../wms/pages/WmsCycleCountSetup';
import WmsReports from '../wms/pages/WmsReports';

export interface RouteComponentEntry {
  component: React.ComponentType<any>;
  title: string;
  titleEn?: string;
}

export const ROUTE_COMPONENT_MAP: Record<string, RouteComponentEntry> = {
  '/accounting/dashboard': { component: AccountingDashboard, title: 'Yönetici Ekranı', titleEn: 'Admin Screen' },
  '/hizli-baslangic': { component: QuickStartPage, title: 'Hızlı Başlangıç', titleEn: 'Quick Start' },
  '/dashboard': { component: Dashboard, title: 'Dashboard' },
  '/tasks': { component: Tasks, title: 'Görevler', titleEn: 'Tasks' },
  '/personnel': { component: Personnel, title: 'Personel', titleEn: 'Personnel' },
  '/shifts': { component: ShiftsPage, title: 'Vardiyalar', titleEn: 'Shifts' },
  '/hr/pdks': { component: PdksManagement, title: 'PDKS', titleEn: 'PDKS' },
  '/reports': { component: Reports, title: 'Görev Raporları', titleEn: 'Task Reports' },
  '/raporlar': { component: ReportsHub, title: 'Raporlar', titleEn: 'Reports' },
  '/messages': { component: Messages, title: 'Mesajlar', titleEn: 'Messages' },
  '/surveys': { component: Surveys, title: 'Anketler', titleEn: 'Surveys' },
  '/events': { component: Events, title: 'Etkinlikler', titleEn: 'Events' },
  '/reservations': { component: Reservations, title: 'Rezervasyonlar', titleEn: 'Reservations' },
  '/branches': { component: BranchesPage, title: 'Şubeler', titleEn: 'Branches' },
  '/customer-screen': { component: CustomerScreenPage, title: 'Müşteri Ekranı', titleEn: 'Customer Screen' },
  '/profile': { component: Profile, title: 'Profil', titleEn: 'Profile' },
  '/ai-kullanim': { component: AiUsagePage, title: 'AI Kullanımı', titleEn: 'AI Usage' },
  '/kullanicilar': { component: UsersPage, title: 'Kullanıcılar', titleEn: 'Users' },

  '/cari': { component: Accounts, title: 'Cari Hesaplar', titleEn: 'Current Accounts' },
  '/cari-hareket-raporu': { component: AccountMovementsReport, title: 'Cari Hareket Raporu', titleEn: 'Account Movements Report' },
  '/stok/lotlar': { component: LotsPage, title: 'Lotlar', titleEn: 'Lots' },
  '/stok': { component: Inventory, title: 'Ürün ve Stok', titleEn: 'Products and Stock' },
  '/sube-fiyatlari': { component: BranchPrices, title: 'Şube Fiyatları', titleEn: 'Branch Prices' },
  '/accounting/mail-raporlari': { component: MailReports, title: 'Otomatik Mail Raporları', titleEn: 'Automated Mail Reports' },
  '/resim-kutuphanesi': { component: ImageLibrary, title: 'Resim Kütüphanesi', titleEn: 'Image Library' },
  '/etiket-yazdirma': { component: LabelPrintingPage, title: 'Etiket Yazdırma', titleEn: 'Label Printing' },
  '/stok-hareket-raporu': { component: StockMovementsReport, title: 'Stok Hareket Raporu', titleEn: 'Stock Movement Report' },
  '/fiyat-degisim-loglari': { component: PriceChangeLogs, title: 'Fiyat Değişim Logları', titleEn: 'Price Change Logs' },
  '/basit-uretim-receteleri': { component: ProductRecipes, title: 'Basit Üretim Reçeteleri', titleEn: 'Simple Production Recipes' },
  '/urun-menuleri': { component: ProductMenus, title: 'Menüler', titleEn: 'Menus' },
  '/banka': { component: Bank, title: 'Banka', titleEn: 'Bank' },
  '/krediler': { component: Loans, title: 'Krediler', titleEn: 'Loans' },
  '/kredi-odemeleri': { component: LoanPayments, title: 'Kredi Ödemeleri', titleEn: 'Loan Payments' },
  '/bank/transactions': { component: BankTransactionReport, title: 'Banka İşlemleri', titleEn: 'Bank Transactions' },
  '/kasa': { component: Cashbox, title: 'Kasa', titleEn: 'Cashbox' },
  '/accounting/cashbox': { component: Cashbox, title: 'Kasa', titleEn: 'Cashbox' },
  '/depo': { component: Warehouse, title: 'Depo', titleEn: 'Warehouse' },
  '/uretim/fisler': { component: ProductionOrders, title: 'Üretim Fişleri', titleEn: 'Production Orders' },
  '/uretim/planlama': { component: ProductionPlanning, title: 'Planlama', titleEn: 'Planning' },
  '/uretim/agac': { component: ProductionTree, title: 'Ürün Ağacı', titleEn: 'Product Tree' },
  '/uretim/raporlar': { component: ProductionReports, title: 'Üretim Raporları', titleEn: 'Production Reports' },
  '/uretim/tanimlar': { component: ProductionDefinitions, title: 'Tanımlar', titleEn: 'Definitions' },
  '/uretim/atolye': { component: ProductionWorkshop, title: 'Atölye', titleEn: 'Workshop' },
  '/doviz': { component: Currency, title: 'Döviz', titleEn: 'Currency' },
  '/fatura/alis': { component: Invoice, title: 'Faturalar', titleEn: 'Invoices' },
  '/fatura/satis': { component: Invoice, title: 'Faturalar', titleEn: 'Invoices' },
  '/fatura/raporlar': { component: InvoiceReports, title: 'Fatura Raporları', titleEn: 'Invoice Reports' },
  '/e-fatura': { component: EInvoice, title: 'E-Fatura', titleEn: 'E-Invoice' },
  '/e-fatura/pavopay-entegrasyonlar': { component: PavoPayIntegrations, title: 'PavoPay Entegrasyonları', titleEn: 'PavoPay Integrations' },
  '/teklifler': { component: Offers, title: 'Teklifler', titleEn: 'Offers' },
  '/irsaliyeler': { component: Waybills, title: 'İrsaliyeler', titleEn: 'Waybills' },
  '/siparisler': { component: AccountingOrdersPage, title: 'Siparişler', titleEn: 'Orders' },
  '/firmalar-arasi-b2b': { component: AccountingOrdersPage, title: 'B2B Siparişi', titleEn: 'B2B Orders' },
  '/cek-senet': { component: ChecksNotes, title: 'Çek/Senet', titleEn: 'Checks / Promissory Notes' },
  '/projeler': { component: Projects, title: 'Projeler', titleEn: 'Projects' },
  '/kar-zarar': { component: ProfitLoss, title: 'Kâr-Zarar', titleEn: 'Profit & Loss' },
  '/gider-turleri': { component: ExpenseCategoriesPage, title: 'Gider Türleri', titleEn: 'Expense Types' },

  '/hizli-satis': { component: QuickSalePage, title: 'Hızlı Satış', titleEn: 'Fast Sale' },
  '/restoran': { component: RestaurantPage, title: 'Restoran', titleEn: 'Restaurant' },
  '/siparis-yonetimi': { component: OrderManagementPage, title: 'Sipariş Yönetimi', titleEn: 'Order Management' },
  '/tum-siparisler': { component: AllOrdersPage, title: 'Tüm Siparişler', titleEn: 'All Orders' },
  '/restaurant-orders': { component: RestaurantOrdersReport, title: 'Restoran Raporları', titleEn: 'Restaurant Reports' },
  '/gun-sonu': { component: EndOfDayReport, title: 'Gün Sonu', titleEn: 'End of Day' },
  '/gun-sonlari': { component: EndOfDayReportsList, title: 'Gün Sonları', titleEn: 'End of Days' },
  '/qr-menu-management': { component: QRMenuPage, title: 'QR Menü', titleEn: 'QR Menu' },
  '/qr-menu/kitchen': { component: KitchenMenuSelection, title: 'Mutfak Ekranı', titleEn: 'Kitchen Screen' },
  '/mutfak-ekrani-secimi': { component: KitchenMenuSelection, title: 'Mutfak Ekranı', titleEn: 'Kitchen Screen' },
  '/qr-menu/customer-display': { component: PoleDisplayMenuSelection, title: 'Müşteri Ekranı', titleEn: 'Customer Screen' },
  '/musteri-ekrani-yonetimi': { component: PoleDisplayManagement, title: 'Müşteri Ekranı Yönetimi', titleEn: 'Customer Screen Management' },
  '/qr-menu/orders': { component: OrdersPage, title: 'QR Siparişler', titleEn: 'QR Orders' },
  '/qr-menu/customers': { component: CustomersPage, title: 'QR Müşteriler', titleEn: 'QR Customers' },
  '/qr-menu/tables': { component: TablesPage, title: 'QR Masalar', titleEn: 'QR Tables' },
  '/kiosk-menu': { component: KioskMenuPage, title: 'Kiosk Menü', titleEn: 'Kiosk Menu' },
  '/kiosk-products': { component: KioskProducts, title: 'Kiosk Ürünler', titleEn: 'Kiosk Products' },
  '/kulup-giris': { component: ClubEntryPage, title: 'Kulüp Giriş', titleEn: 'Club Entry' },
  '/e-commerce': { component: ECommercePage, title: 'E-Ticaret', titleEn: 'E-Commerce' },
  '/kurye': { component: CourierManagement, title: 'Kurye', titleEn: 'Courier' },
  '/entegrasyonlar': { component: IntegrationPage, title: 'Entegrasyonlar', titleEn: 'Integrations' },
  '/hacioglu-urun-eslestirme': { component: HaciogluProductMapping, title: 'Hacıoğlu Eşleştirme', titleEn: 'Hacioglu Mapping' },
  '/cihaz-yonetimi': { component: DeviceManagement, title: 'Cihaz Yönetimi', titleEn: 'Device Management' },
  '/tartilar': { component: ScaleManagement, title: 'Tartılar', titleEn: 'Scales' },
  '/kart-yonetimi/kartlar': { component: Cards, title: 'Kartlar', titleEn: 'Cards' },
  '/kart-yonetimi/oturumlar': { component: CardSessions, title: 'Kart Oturumları', titleEn: 'Card Sessions' },
  '/kart-yonetimi/silinen-kartlar': { component: DeletedCards, title: 'Silinen Kartlar', titleEn: 'Deleted Cards' },
  '/kart-yonetimi/gecis-yonetimi': { component: AccessManagement, title: 'Geçiş Yönetimi', titleEn: 'Access Management' },

  '/ik/izin': { component: LeaveManagementPage, title: 'İzin Yönetimi', titleEn: 'Leave Management' },
  '/ik/performans': { component: PerformanceManagementPage, title: 'Performans', titleEn: 'Performance' },
  '/ik/egitim': { component: TrainingDevelopmentPage, title: 'Eğitim', titleEn: 'Training' },
  '/ik/bordro': { component: PayrollPaymentsPage, title: 'Bordro', titleEn: 'Payroll' },
  '/ik/dokuman': { component: DocumentManagementPage, title: 'Döküman', titleEn: 'Document Management' },
  '/ik/isealim': { component: RecruitmentManagementPage, title: 'İşe Alım', titleEn: 'Recruitment' },

  // WMS - Akıllı Depo
  '/wms/panel': { component: WmsDashboard, title: 'WMS Paneli', titleEn: 'WMS Dashboard' },
  '/wms/depo-tanimlama': { component: WmsWarehouseSetup, title: 'Depo Tanımlama', titleEn: 'Warehouse Setup' },
  '/wms/depo-tanimlama/:warehouseId': { component: WmsLocationManager, title: 'Lokasyon Yönetimi', titleEn: 'Location Management' },
  '/wms/siparis-havuzu': { component: WmsOrderPool, title: 'Sipariş Havuzu', titleEn: 'Order Pool' },
  '/wms/is-emirleri': { component: WmsWaveManagement, title: 'İş Emirleri', titleEn: 'Work Orders' },
  '/wms/toplama-ayarlari': { component: WmsPickingSetup, title: 'Toplama Ayarları', titleEn: 'Picking Settings' },
  '/wms/iptal-yonetimi': { component: WmsCancelManagement, title: 'İptal Yönetimi', titleEn: 'Cancel Management' },
  '/wms/paketleme-ayarlari': { component: WmsPackingSetup, title: 'Paketleme Ayarları', titleEn: 'Packing Settings' },
  '/wms/mal-kabul-ayarlari': { component: WmsReceivingSetup, title: 'Mal Kabul Ayarları', titleEn: 'Receiving Settings' },
  '/wms/stok-sayim-ayarlari': { component: WmsCycleCountSetup, title: 'Stok Sayım Ayarları', titleEn: 'Cycle Count Settings' },
  '/wms/mal-kabul-yonetimi': { component: WmsReceivingManagement, title: 'Mal Kabul Yönetimi', titleEn: 'Receiving Management' },
  '/wms/stok-sayim-yonetimi': { component: WmsCycleCountManagement, title: 'Stok Sayım Yönetimi', titleEn: 'Cycle Count Management' },
  '/wms/ekipman-yonetimi': { component: WmsEquipmentManagement, title: 'Ekipman Yönetimi', titleEn: 'Equipment Management' },
  '/wms/raporlar': { component: WmsReports, title: 'WMS Raporları', titleEn: 'WMS Reports' },
};

export function getRouteTitle(path: string, language?: string): string | null {
  const route = ROUTE_COMPONENT_MAP[path];
  if (!route) return null;

  const isEnglish = (language || '').toLowerCase().startsWith('en');
  return isEnglish ? (route.titleEn || route.title) : route.title;
}

export function isTabManagedRoute(path: string): boolean {
  return path in ROUTE_COMPONENT_MAP;
}

// Aynı sayfayı gösteren rotaları tek sekmede birleştir (örn. alış/satış fatura listesi
// aynı Invoice bileşeni). Sekme açılırken kanonik yol kullanılır; URL değişmez.
const TAB_PATH_ALIASES: Record<string, string> = {
  '/fatura/satis': '/fatura/alis',
  '/firmalar-arasi-b2b': '/siparisler',
};

export function getCanonicalTabPath(path: string): string {
  return TAB_PATH_ALIASES[path] || path;
}

// Sekme olarak yönetilmeyen (form/detay) sayfalar için geçici sekme başlıkları.
// TabBar bu başlığı "hayalet" sekme olarak gösterir; sayfa gerçek bir sekmeye dönüşmez.
const TRANSIENT_ROUTE_TITLES: Array<{ pattern: RegExp; title: string; titleEn: string }> = [
  { pattern: /^\/fatura\/satis\/yeni$/, title: 'Yeni Satış Faturası', titleEn: 'New Sales Invoice' },
  { pattern: /^\/fatura\/alis\/yeni$/, title: 'Yeni Alış Faturası', titleEn: 'New Purchase Invoice' },
  { pattern: /^\/fatura\/satis\/duzenle\//, title: 'Satış Faturası Düzenle', titleEn: 'Edit Sales Invoice' },
  { pattern: /^\/fatura\/alis\/duzenle\//, title: 'Alış Faturası Düzenle', titleEn: 'Edit Purchase Invoice' },
  { pattern: /^\/teklifler\/(satis|verilen)\/yeni$/, title: 'Yeni Satış Teklifi', titleEn: 'New Sales Offer' },
  { pattern: /^\/teklifler\/(alis|alinan)\/yeni$/, title: 'Yeni Alış Teklifi', titleEn: 'New Purchase Offer' },
  { pattern: /^\/teklifler\/(satis|verilen)\/duzenle\//, title: 'Satış Teklifi Düzenle', titleEn: 'Edit Sales Offer' },
  { pattern: /^\/teklifler\/(alis|alinan)\/duzenle\//, title: 'Alış Teklifi Düzenle', titleEn: 'Edit Purchase Offer' },
  { pattern: /^\/teklifler\/sablon-editor$/, title: 'Teklif Şablon Editörü', titleEn: 'Offer Template Editor' },
  { pattern: /^\/irsaliye\/yeni$/, title: 'Yeni İrsaliye', titleEn: 'New Waybill' },
  { pattern: /^\/irsaliye\/duzenle\//, title: 'İrsaliye Düzenle', titleEn: 'Edit Waybill' },
  { pattern: /^\/siparis\/satis\/yeni$/, title: 'Yeni Satış Siparişi', titleEn: 'New Sales Order' },
  { pattern: /^\/siparis\/alis\/yeni$/, title: 'Yeni Alış Siparişi', titleEn: 'New Purchase Order' },
  { pattern: /^\/siparis\/satis\/duzenle\//, title: 'Satış Siparişi Düzenle', titleEn: 'Edit Sales Order' },
  { pattern: /^\/siparis\/alis\/duzenle\//, title: 'Alış Siparişi Düzenle', titleEn: 'Edit Purchase Order' },
  { pattern: /^\/uretim\/yeni$/, title: 'Yeni Üretim Fişi', titleEn: 'New Production Order' },
  { pattern: /^\/uretim\/fis\//, title: 'Üretim Fişi', titleEn: 'Production Order' },
];

export function getTransientRouteTitle(path: string, language?: string): string | null {
  const entry = TRANSIENT_ROUTE_TITLES.find(e => e.pattern.test(path));
  if (!entry) return null;
  const isEnglish = (language || '').toLowerCase().startsWith('en');
  return isEnglish ? entry.titleEn : entry.title;
}
